// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info .ant-row {\n  width: 50%;\n  margin-right: 0 !important;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
